
   <template>
  <b-sidebar
    id="sidebar-add-new-customer"
    sidebar-class="sidebar-lg"
    bg-variant="white"
    shadow
    backdrop
    no-header
    right
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">Add Client</h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- Body -->
      <b-form class="p-2" @submit.prevent>
        <!-- name -->
        <b-form-group label="Nom" label-for="v-name">
          <b-form-input id="v-name" placeholder="Nom" v-model="client.firstName" />
        </b-form-group>

        <!-- Prénom -->
        <b-form-group label="Prénom" label-for="v-lastName">
          <b-form-input
            id="v-lastName"
            placeholder="Prénom"
            v-model="client.lastName"
          />
        </b-form-group>

        <!-- email -->
        <b-form-group label="Email" label-for="v-email">
          <b-form-input
            id="v-email"
            placeholder="email"
            v-model="client.email"
          />
        </b-form-group>

        <!-- Prix ht -->
        <b-form-group label="Numéro de téléphone" label-for="v-telNumbers">
          <b-form-input
            id="v-telNumbers"
            placeholder="99 888 777"
            v-model="client.telNumbers[0]"
          />
        </b-form-group>

        <!-- Form Actions -->
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
            @click="addClient(), hide"
          >
            Add Client
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="hide"
          >
            Close
          </b-button>
        </div>
      </b-form>
    </template>
  </b-sidebar>
</template>

<script>
import axios from "axios";

import {
  BSidebar,
  BForm,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BButton,
} from "bootstrap-vue";
import { ref } from "@vue/composition-api";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  components: {
    ToastificationContent,
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormTextarea,
    BButton,
    vSelect,
  },
  directives: {
    Ripple,
  },
  setup() {
    const client = ref({
      firstName: "",
      lastName: "",
      email: "",
      telNumbers: [],
    });

    return {
      client,
    };
  },
  methods: {
    addClient() {
      this.client.createdBy= JSON.parse(localStorage.getItem("userData"))._id,
      axios
        .post(
          "https://mtl-feeder-nodejs.onrender.com/api/customers",
          this.client
        )
        .then((response) => {
          console.log(response);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Client bien ajouté",
              icon: "EditIcon",
              variant: "success",
            },
          });
          this.$emit("update-client", this.client);
        })
        .catch((error) => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Erreur lors de l'ajout du client",
              icon: "EditIcon",
              variant: "danger",
            },
          });
          this.errorMessage = error.message;
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
